export default __webpack_public_path__ + "static/media/Bathroom.2260b060.png";